import React from 'react';
import '../ListAccounts/List.scss';
import { ReactComponent as Minus } from '../../style/_assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../style/_assets/icons/plus.svg';
import Label from 'components/form/Label/Label';
import { commafy, decommafy } from 'helpers/number';
import classnames from 'classnames';
import { isEnterKey } from 'hook/helper.hook';

export const getTotal = accounts => {
  let sum = 0;
  accounts.forEach(account => {
    account.pastDue = decommafy(account.pastDue);
    if (!isNaN(account.pastDue)) {
      sum += parseInt(account.pastDue, 10);
    }
  });
  return commafy(sum);
};

export default function ListHeader({
  headerText,
  isListExpanded,
  datatestid,
  onClick,
  numAccounts,
  hideCount,
  accounts,
  listType,
  type,
  iconClass,
  isFAQTitleBold,
  showMinusIcon = true,
  ...props
}) {
  const ariLabelHeaderText =
    typeof headerText === 'object' ? headerText?.props?.children : headerText;

  return (
    <div
      className={classnames('listContainer', {
        margb8: isListExpanded,
      })}
      tabIndex={'0'}
      role="group"
      onKeyDown={e => {
        if (isEnterKey(e)) onClick(e);
      }}
      {...props}
    >
      {listType === 'simple' ? (
        <div
          data-testid={datatestid ? `${datatestid}-simpleHeaderTitle` : null}
          className={classnames('simpleHeaderText', {
            bold: isFAQTitleBold,
          })}
          onClick={onClick}
        >
          {headerText}
        </div>
      ) : (
        <div
          data-testid={datatestid ? `${datatestid}-listHeaderExpand` : null}
          className={`expandableHeader`}
          onClick={onClick}
          aria-label={ariLabelHeaderText}
          role="group"
        >
          <div
            data-testid={datatestid ? `${datatestid}-minusPlus` : null}
            className={classnames({
              [iconClass]: iconClass,
              margLR12: showMinusIcon && !iconClass,
              margL6: !showMinusIcon,
            })}
          >
            {isListExpanded ? (
              showMinusIcon ? (
                <Minus className="minus" />
              ) : (
                <></>
              )
            ) : (
              <Plus className="plus" aria-label="plus-icon" />
            )}
          </div>
          <Label
            type="H5"
            tabIndex={'-1'}
            datatestid={
              datatestid ? `${datatestid}-listHeaderExpand-listTitle` : null
            }
            className="expandableHeaderText"
          >
            {headerText} {!hideCount && `(${numAccounts})`}
          </Label>

          {(type === 'studentLoanDebt' ||
            type === 'homeLoanDebt' ||
            type === 'otherLoanDebt' ||
            type === 'autoLoanDebt' ||
            type === 'autoLoanDebt' ||
            type === 'creditCardDebt') && (
            <Label
              type="H5"
              className="expandableHeaderTotal mCaption"
              tabIndex="-1"
            >
              {'$' + commafy(getTotal(accounts))}
            </Label>
          )}
        </div>
      )}
    </div>
  );
}
